import React from "react";
import { Zap } from "lucide-react";

export const QuickAnswer = ({ children }) => (
  <div className="max-w-7xl mx-auto px-6">
    <div className="p-6 bg-[#121214] border-l-2 border-[#9D0423] border-y border-r border-y-white/5 border-r-white/5" data-testid="quick-answer">
      <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.24em] text-[#E56A79] mb-3">
        <Zap size={12} /> Quick answer
      </p>
      <p className="text-[15px] text-neutral-200 leading-relaxed" data-speakable="true">{children}</p>
    </div>
  </div>
);
